<template>
  <div class="order-container">
    <div class="order-item" v-if="order.template_image_url !== ''">
      <div class="label-col">
        <span class="label">选择模板</span>
      </div>
      <div class="content-col">
        <a-image
          :src="ToImage(order.template_image_url)"
          width="100px"
          class="template-image"
          :preview="true"
        />
      </div>
    </div>

    <div class="order-item">
      <div class="label-col">
        <span class="label">模板费用</span>
      </div>
      <div class="content-col">
        <span class="price-value">{{ formatPrice(order.template_price) }}</span>
      </div>
    </div>
    <div class="order-item">
      <div class="label-col">
        <span class="label">信件内容</span>
        <div class="label-action">
          <a-button
            type="primary"
            size="small"
            @click="
              setParam(
                order.title,
                order.content,
                order.author,
                order.write_date,
                order.send_province,
                order.send_city,
                order.send_district,
                order.send_address,
                order.send_phone,
                order.send_name
              )
            "
          >
            计算制作
          </a-button>
        </div>
        <div class="label-action">
          <a-button
            type="primary"
            size="small"
            @click="a4print(0, order.template_image_url, order.recipient_name)"
          >
            A4打印页面1
          </a-button>
        </div>
        <div class="label-action">
          <a-button
            type="primary"
            size="small"
            @click="a4print(37, order.template_image_url, order.recipient_name)"
          >
            A4打印页面2
          </a-button>
        </div>
        <div class="label-action">
          <a-button
            type="primary"
            size="small"
            @click="a4print(74, order.template_image_url, order.recipient_name)"
          >
            A4打印页面3
          </a-button>
        </div>
        <div class="label-action">
          <a-button
            type="primary"
            size="small"
            @click="
              copyContent(
                getContent(
                  order.title,
                  order.content,
                  order.author,
                  order.write_date,
                  order.send_province,
                  order.send_city,
                  order.send_district,
                  order.send_address,
                  order.send_phone,
                  order.send_name
                )
              )
            "
          >
            一键复制
          </a-button>
        </div>
      </div>
      <div class="content-col">
        <div class="content-text">
          {{
            getContent(
              order.title,
              order.content,
              order.author,
              order.write_date,
              order.send_province,
              order.send_city,
              order.send_district,
              order.send_address,
              order.send_phone,
              order.send_name
            )
          }}
        </div>
      </div>
    </div>
    <!--  <div class="order-item">
      <div class="label-col">
        <span class="label">信件内容</span>
        <div class="label-action">
          <a-button
            type="primary"
            size="small"
            @click="copyContent(order.content)"
          >
            一键复制
          </a-button>
        </div>
      </div>
      <div class="content-col">
        <div class="content-text">
          {{ order.content }}
        </div>
      </div>
    </div>

    <div class="order-item">
      <div class="label-col">
        <span class="label">信件作者</span>
        <div class="label-action">
          <a-button
            type="primary"
            size="small"
            @click="copyContent(order.author)"
          >
            一键复制
          </a-button>
        </div>
      </div>
      <div class="content-col">
        <div class="content-text">
          {{ order.author }}
        </div>
      </div>
    </div>

    <div class="order-item">
      <div class="label-col">
        <span class="label">信件时间</span>
        <div class="label-action">
          <a-button
            type="primary"
            size="small"
            @click="copyContent(order.write_date)"
          >
            一键复制
          </a-button>
        </div>
      </div>
      <div class="content-col">
        <div class="content-text">
          {{ order.write_date }}
        </div>
      </div>
    </div>-->

    <div class="order-item-line">
      <div class="label-col-line">
        <span class="label">邮寄方式</span>
      </div>
      <div class="content-col-line">
        <div class="content-text">{{ order.mail_method_name }}</div>
      </div>
      <div class="label-col-line">
        <span class="label">信件类型</span>
      </div>
      <div class="content-col-line">
        <div class="content-text">
          {{ getCategory(order.write_category, order.category) }}
        </div>
      </div>
      <div class="label-col-line">
        <span class="label">代收</span>
      </div>
      <div class="content-col-line">
        <div class="content-text">
          {{ order.reply }}
        </div>
      </div>
      <div class="label-col-line">
        <span class="label">邮寄费用</span>
      </div>
      <div class="content-col-line">
        <span class="price-value">{{
          formatPrice(order.mail_method_price)
        }}</span>
      </div>
    </div>

    <div class="order-item">
      <div class="label-col">
        <span class="label">上传照片</span>
        <div class="label-action">
          <a-button type="primary" size="small" @click="handleDownload">
            一键下载
          </a-button>
        </div>
      </div>
      <div class="content-col">
        <a-image
          width="200px"
          v-for="i in order.image_url"
          :key="i"
          :src="ToImage(i)"
        />
      </div>
    </div>

    <div class="order-item">
      <div class="label-col">
        <span class="label">图片费用</span>
      </div>
      <div class="content-col">
        <span class="price-value">
          {{ formatPrice(countImage(order.image_url)) }}
        </span>
      </div>
    </div>

    <div class="order-item">
      <div class="label-col">
        <span class="label">商品列表</span>
      </div>
      <div class="content-col">
        <div class="product-list">
          <div class="product-header">
            <div class="header-item">商品图片</div>
            <div class="header-item">商品名称</div>
            <div class="header-item">商品单价</div>
            <div class="header-item">商品运费</div>
            <div class="header-item">商品数量</div>
          </div>

          <div
            v-for="product in order.items"
            :key="product.id"
            class="product-item"
          >
            <div class="item-image">
              <a-image
                :src="ToImage(product.image_url?.[0])"
                class="product-image"
                :preview="false"
              />
            </div>
            <div class="item-name">{{ product.name }}</div>
            <div class="item-price">{{ formatPrice(product.price) }}</div>
            <div class="item-fright">{{ formatPrice(product.fright) }}</div>
            <div class="item-quantity">{{ product.num }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="order-item">
      <div class="label-col">
        <span class="label">商品费用</span>
      </div>
      <div class="content-col">
        <span class="price-value">
          {{ formatPrice(countProduct(order?.items)) }}
        </span>
      </div>
    </div>

    <div class="order-item">
      <div class="label-col">
        <span class="label">交易订单号</span>
      </div>
      <div class="content-col">
        <div class="content-text">{{ order.order_id }}</div>
      </div>
    </div>

    <div class="order-item">
      <div class="label-col">
        <span class="label">物流订单号</span>
      </div>
      <div class="content-col">
        <div class="content-text">{{ order.delivery_number }}</div>
      </div>
    </div>

    <div class="order-item">
      <div class="label-col">
        <span class="label">寄件人地址</span>
        <div class="label-action">
          <a-button
            type="primary"
            size="small"
            @click="
              copyContent(
                order.send_province +
                  order.send_city +
                  order.send_district +
                  order.send_address
              )
            "
          >
            一键复制
          </a-button>
        </div>
      </div>
      <div class="content-col">
        <div class="content-text">
          <span class="span-text">{{ order.send_province }}</span>
          <span class="span-text">{{ order.send_city }}</span>
          <span class="span-text">{{ order.send_district }}</span>
          <span class="span-text">{{ order.send_address }}</span>
        </div>
      </div>
    </div>

    <div class="order-item-line">
      <div class="label-col-line">
        <span class="label">寄件人姓名</span>
      </div>
      <div class="content-col-line">
        <div class="content-text">{{ order.send_name }}</div>
      </div>
      <div class="label-col-line">
        <span class="label">寄件人电话</span>
      </div>
      <div class="content-col-line">
        <div class="content-text">{{ order.send_phone }}</div>
      </div>
      <div class="label-col-line">
        <span class="label">寄件人地址邮编</span>
      </div>
      <div class="content-col-line">
        <div class="content-text">{{ order.send_postcode }}</div>
      </div>
    </div>
    <div class="order-item">
      <div class="label-action">
        <a-button
          type="primary"
          size="small"
          @click="
            copyAddress(
              order.recipient_province +
                order.recipient_city +
                order.recipient_district +
                order.recipient_address,
              order.recipient_name,
              order.recipient_phone,
              order.send_name,
              order.send_phone,
              order.relationship
            )
          "
        >
          一键复制所有
        </a-button>
      </div>
      <span class="label"
        >-------------------------------------------------------------------------------------------------分割线
        ----------------------------------------------------------------------------------------------------------</span
      >
    </div>
    <div class="order-item">
      <div class="label-col">
        <span class="label">收件人地址</span>
        <div class="label-action">
          <a-button
            type="primary"
            size="small"
            @click="
              copyContent(
                order.recipient_province +
                  order.recipient_city +
                  order.recipient_district +
                  order.recipient_address
              )
            "
          >
            一键复制
          </a-button>
        </div>
      </div>
      <div class="content-col">
        <div class="content-text">
          <span class="span-text">{{ order.recipient_province }}</span>
          <span class="span-text">{{ order.recipient_city }}</span>
          <span class="span-text">{{ order.recipient_district }}</span>
          <span class="span-text">{{ order.recipient_address }}</span>
        </div>
      </div>
    </div>
    <div class="order-item-line">
      <div class="label-col-line">
        <span class="label">收件人姓名</span>
      </div>
      <div class="content-col-line">
        <div class="content-text">{{ order.recipient_name }}</div>
      </div>
      <div class="label-col-line">
        <span class="label">收件人电话</span>
      </div>
      <div class="content-col-line">
        <div class="content-text">{{ order.recipient_phone }}</div>
      </div>
      <div class="label-col-line">
        <span class="label">关系</span>
      </div>
      <div class="content-col-line">
        <div class="content-text">{{ order.relationship }}</div>
      </div>
      <div class="label-col-line">
        <span class="label">收件地址邮编</span>
      </div>
      <div class="content-col-line">
        <div class="content-text">{{ order.recipient_postcode }}</div>
      </div>
    </div>

    <div class="order-item">
      <div class="label-col">
        <span class="label">总费用</span>
      </div>
      <div class="content-col">
        <span class="price-value">
          {{ formatPrice(order.total_price) }}
        </span>
      </div>
    </div>

    <div class="order-item-line">
      <div class="label-col-line">
        <span class="label">支付时间</span>
      </div>
      <div class="content-col-line">
        <div class="content-text">
          {{ dayjs(order.create_at).format("YYYY-MM-DD HH:mm:ss") }}
        </div>
      </div>
      <div class="label-col-line">
        <span class="label">修改时间</span>
      </div>
      <div class="content-col-line">
        <div class="content-text">
          {{ dayjs(order.update_at).format("YYYY-MM-DD HH:mm:ss") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ProductOrder } from "@/api/models/product_order/ProductOrder";
import { PropType } from "vue";
import { ToImage } from "@/utils/image";
import { message } from "ant-design-vue";
import { FileService } from "@/api/services/FileService";
import { countImage, countProduct } from "./count";
import dayjs from "dayjs";
import { onMounted, ref } from "vue";

const canvasRef = ref<HTMLCanvasElement | null>(null);
let ctx: CanvasRenderingContext2D | null = null;
let lineArray = ref<string[]>([]);
let pwidth = 750;
let totalPrint = 1;

const props = defineProps({
  order: {
    type: Object as PropType<ProductOrder>,
    required: true,
  },
});

const getCategory = (write: number, category: number) => {
  // write 1在线，2手写，3钢笔 category：商品，信件，明信片
  var r = "";
  if (category === 1) {
    r = "商品订单";
  } else if (category === 2) {
    r = "信件订单";
  } else if (category === 3) {
    r = "明信片订单";
  }
  if (write === 1) {
    r += "  在线填写";
  } else if (write === 2) {
    r += "  手写拍照";
  } else if (write === 3) {
    r += "  钢笔代写";
  }
  return r;
};

const getContent = (
  title: string,
  content: string,
  author: string,
  write_date: string,
  send_province: string,
  send_city: string,
  send_district: string,
  send_address: string,
  phone: string,
  name: string
) => {
  return (
    title +
    "\n" +
    content +
    "\n" +
    send_province +
    send_city +
    send_district +
    send_address +
    "  " +
    phone +
    "  " +
    name +
    "\n" +
    author +
    "\n" +
    write_date
  );
};
const formatPrice = (price: number) => {
  return `￥${price.toFixed(2)}`;
};

const copyContent = async (content: string) => {
  await navigator.clipboard.writeText(content);
  message.success("复制成功");
};

const wrapText = (
  ctx: CanvasRenderingContext2D,
  context: string,
  maxWidth: number,
  lineHeight: number
) => {
  if (context.length == 0) return lineArray.value.length * lineHeight;
  // 针对中文：按字符分割
  const chars = context.split("");
  let line = "";
  let testLine = "";
  for (let i = 0; i < chars.length; i++) {
    testLine = line + chars[i];

    const metrics = ctx.measureText(testLine);
    const testWidth = metrics.width;

    // 如果超过最大宽度，保存当前行（最后一个字符不包含）
    if (testWidth > maxWidth && i > 0) {
      console.log(line);
      lineArray.value.push(line);
      line = chars[i]; // 新行从当前字符开始
    } else {
      line = testLine;
    }
  }
  console.log(line);
  lineArray.value.push(line);
  // 绘制所有行
  // for (let i = 0; i < lineArray.length; i++) {
  //   ctx.fillText(lineArray[i], x, y + i * lineHeight);
  //   if (i > 37) {
  //     // 一页最多37行
  //   }
  // }
  //alert(lineArray.value.length);
  return lineArray.value.length * lineHeight;
};
const setParam = async (
  title: string,
  content: string,
  author: string,
  write_date: string,
  send_province: string,
  send_city: string,
  send_district: string,
  send_address: string,
  phone: string,
  name: string
) => {
  const printCanvas = document.createElement("canvas");
  printCanvas.width = 795; // 打印区域的宽度
  printCanvas.height = 1135; // 打印区域的高度

  const printCtx = printCanvas.getContext("2d");
  lineArray.value.length = 0;
  if (printCtx) {
    printCtx.fillStyle = "black"; // 可以为打印区域添加背景色或其他装饰。
    printCtx.font = "20px Arial";
    printCtx.fillStyle = "black";
    //printCtx.fillText(title, 30, 50, 750);
    wrapText(printCtx, title, pwidth, 30);
    wrapText(printCtx, content, pwidth, 30);
    wrapText(printCtx, "\r\n", pwidth, 30);
    wrapText(
      printCtx,
      send_province +
        send_city +
        send_district +
        send_address +
        "," +
        phone +
        "," +
        name,
      pwidth,
      30
    );
    wrapText(printCtx, author, pwidth, 30);
    wrapText(printCtx, write_date, pwidth, 30);
    totalPrint = lineArray.value.length;
    //alert(totalPrint);
    message.success("制作完成，可以打印");
  }
};

const a4print = async (pcount: number, tempurl: string, rname: string) => {
  // 使用 ctx 进行绘图
  // 创建一个新的Canvas用于打印部分区域，例如打印上半部分
  if (pcount >= totalPrint) return;
  const printCanvas = document.createElement("canvas");
  printCanvas.width = 795; // 打印区域的宽度
  printCanvas.height = 1135; // 打印区域的高度

  const printCtx = printCanvas.getContext("2d");

  if (printCtx) {
    const image = new Image();
    image.src = ToImage(tempurl); // 替换为你的图片路径
    // image.src =
    //   "https://jxkapi.jixinkuai.com/api/file/2025/04/01/d0ce04ce-4e9f-4e4a-a86b-d450c27acab2.png";
    image.crossOrigin = "Anonymous";
    image.onload = () => {
      printCtx.drawImage(image, 0, 0, printCanvas.width, printCanvas.height);
      printCtx.fillStyle = "black"; // 可以为打印区域添加背景色或其他装饰。
      printCtx.font = "20px Arial";
      printCtx.fillStyle = "black";
      //printCtx.fillText(title, 30, 50, pwidth);
      for (let i = pcount; i < lineArray.value.length; i++) {
        if (lineArray.value.length - i <= 3) {
          // 靠右
          //printCtx.textAlign = "right";
          const textWidth = printCtx.measureText(lineArray.value[i]).width;
          // 设置x坐标为x值减去文本宽度，以实现右对齐
          const rightAlignedX = pwidth - textWidth;
          // 使用fillText方法绘制文本
          printCtx.fillText(
            lineArray.value[i],
            rightAlignedX,
            50 + (i - pcount) * 30
          );
          //printCtx.fillText(lineArray.value[i], 30, 50 + (i - pcount) * 30);
        } else {
          printCtx.fillText(lineArray.value[i], 30, 50 + (i - pcount) * 30);
        }
        if (i > 37 + pcount) {
          // 一页最多37行
          break;
        }
      }
      // printCtx.fillText(content, 30, 50, 750);
    };
    // printCtx.drawImage(canvas, 0, 0, 400, 200, 0, 0, 400, 200); // 从原Canvas的(0,0)开始，宽度400，高度200的区域复制到新Canvas的(0,0)位置，保持原图大小不变。
    // 可以选择直接打开新Canvas的图像或者进行其他处理，例如保存或打印等。

    //printCtx.fillRect(0, 0, printCanvas.width, printCanvas.height); // 例如，添加黑色背景。
    const win = window.open("", "_blank");
    printCanvas.toBlob((blob) => {
      if (blob != null) {
        //const url = URL.createObjectURL(blob);
        try {
          const dataUrl = printCanvas.toDataURL("image/png");
          const tile = rname + "家属的信件";
          if (win && dataUrl) {
            win.document.open();
            win.document.write(`
                <html>
                    <head>
                        <title>"${tile}"</title>
                    </head>
                    <body>
                        <img src="${dataUrl}" alt="Printed Canvas" />
                    </body>
                </html>
            `);

            win.document.close();
            setTimeout(() => {
              win.print();
              // 打印后关闭窗口（可选）
              win.close();
            }, 500);
          }
          //console.log(dataURL);
        } catch (error) {
          console.error("Failed to export canvas:", error);
        }
      }
    });
  }
  // 绘制指定区域的图像到新的Canvas上
  // 使用window.open打开新窗口显示打印内容（仅为示例，实际应用中可能需要根据需求调整）
};

const copyAddress = async (
  content: string,
  rName: string,
  rPhone: string,
  sName: string,
  sPhone: string,
  sRelationship: string
) => {
  var value;
  value = "收件人:\n";
  value += content;
  value += "\n   " + rName;
  value += "  " + rPhone;
  value += "\n----------------------------------------\n寄件人:\n";
  value += "广东省广州市黄埔区易博士大厦526(芳 18681417165)\n";
  value += "   " + sName;
  value += "  " + sPhone;
  value += " (关系:" + sRelationship + ")";
  await navigator.clipboard.writeText(value);
  message.success("复制成功");
};

const handleDownload = async () => {
  for (const image of props.order?.image_url) {
    await FileService.Download({ filename: image });
  }
};
</script>

<style scoped>
.order-container {
  width: 100%;
  padding: 16px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.order-item {
  display: flex;
  margin-bottom: 20px;
  align-items: flex-start;
}

.label-col {
  width: 120px;
  flex-shrink: 0;
  align-items: center;
}

.content-col {
  flex: 1;
  min-width: 0;
  align-items: center;
}

.order-item-line {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px;
}

.label-col-line {
  display: flex;
  align-items: center;
}

.content-col-line {
  flex: 1;
  min-width: 0;
  align-items: center;
}

.label {
  font-size: 14px;
  color: #666;
  font-weight: 500;
  display: block;
  margin-bottom: 8px;
}

.label-action {
  margin-top: 4px;
}

.template-image {
  border-radius: 4px;
  border: 1px solid #f0f0f0;
}

.price-value {
  font-size: 16px;
  color: #ff4d4f;
  font-weight: 500;
}

.content-text {
  padding: 12px;
  background: #fafafa;
  border-radius: 4px;
  border: 1px solid #f0f0f0;
  word-break: break-all;
  line-height: 1.5;
  color: #333;
}

.span-text {
  margin-right: 4px;
}

.product-list {
  width: 100%;
  padding: 16px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.product-header {
  display: flex;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;
  font-weight: 500;
  color: #333;
}

.header-item {
  flex: 1;
  text-align: center;
  font-size: 14px;
}

.product-item {
  display: flex;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;
}

.product-item:last-child {
  border-bottom: none;
}

.item-image {
  flex: 1;
  display: flex;
  justify-content: center;
}

.product-image {
  height: 100px;
  width: auto;
  border-radius: 8px;
  border: 1px solid #f0f0f0;
}

.item-name,
.item-price,
.item-fright,
.item-quantity {
  flex: 1;
  text-align: center;
  font-size: 14px;
  color: #666;
}

.item-price,
.item-fright {
  font-weight: 500;
  color: #ff4d4f;
}
</style>
